import { memo, useCallback } from 'react';

import classNames from 'classnames';

import { useIsRouteSegment } from '@shared/hooks';
import { UiButton } from '@shared/ui';

import cls from './MeasurementsModal.module.css';
import { MeasurementsModalBody } from './MeasurementsModalBody/MeasurementsModalBody';
import { MeasurementsModalFooter } from './MeasurementsModalFooter/MeasurementsModalFooter';
import { MeasurementsModalHeader } from './MeasurementsModalHeader/MeasurementsModalHeader';
import { useMeasurementsModal } from './useMeasurementsModal';
import { Icon } from '../../../components/newUI/Icon/Icon';
import { Loader } from '../../../components/UI/NewLoader/Loader/Loader';

export const MeasurementsModal = memo(({ isClosing, onHideModal }) => {
    const { isShowModal, currentCardId, modalLoading, isEdited } =
        useMeasurementsModal(onHideModal);
    const fromCrm = useIsRouteSegment('crm');

    const onHideModalCb = useCallback(() => {
        onHideModal(isEdited);
    }, [isEdited]);

    if (!isShowModal) {
        return null;
    }

    return (
        <div
            onClick={(event) => event.stopPropagation()}
            className={classNames(cls.MeasurementsModal, {
                [cls.show]: isShowModal,
                [cls.hide]: isClosing,
                [cls.fromCrm]: fromCrm,
            })}
        >
            {modalLoading && <Loader variant="light" />}
            <MeasurementsModalHeader
                title={
                    !currentCardId
                        ? i18next.t('MeasurementsModal.return.MeasurementsModalHeader.addTitle')
                        : i18next.t('MeasurementsModal.return.MeasurementsModalHeader.editTitle')
                }
            >
                <div className={cls.closeIcon}>
                    <UiButton
                        onClick={onHideModalCb}
                        variant="icon"
                        startIcon={<Icon iconName="closeModal" />}
                    />
                </div>
            </MeasurementsModalHeader>
            <MeasurementsModalBody />
            <MeasurementsModalFooter onHideModal={onHideModal} />
        </div>
    );
});
